import { axios } from "@Root/API";

export const getProgrammesListOptions = () => {
  return axios.get("list-programs-for-select");
};
